import React from 'react';

function FaqAccess(
  props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>
): JSX.Element {
  return (
    <svg
      width={52}
      height={52}
      viewBox='0 0 52 52'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <rect width={52} height={52} rx={4} fill='#DFD8F3' />
      <mask
        id='mask0_9879_72218'
        style={{
          maskType: 'alpha'
        }}
        maskUnits='userSpaceOnUse'
        x={10}
        y={10}
        width={32}
        height={32}
      >
        <rect x={10} y={10} width={32} height={32} fill='#D9D9D9' />
      </mask>
      <g mask='url(#mask0_9879_72218)'>
        <path
          d='M26 12C30.8533 12.0001 33.3191 16.0352 33.3193 18.6465V22.502H34.4893C35.5495 22.4611 36.9733 23.4701 36.9736 24.877L37 37.7031C36.945 38.6198 36.1051 39.8606 34.6035 40H17.3281C16.2296 39.8876 15.1353 38.963 15.001 37.6982V24.9805C15.001 23.6347 16.2957 22.502 17.4033 22.502H18.6738V18.6465C18.674 15.9862 21.1466 12 26 12ZM25.8789 27.1562C24.3692 27.2221 23.2713 28.6426 23.6299 30.0371C23.8016 30.7048 24.2518 31.1375 24.793 31.5469C24.793 32.4226 24.8018 33.3286 24.8018 34.2686C24.8018 35.6596 27.2061 35.6472 27.2061 34.2686C27.2061 33.3301 27.2148 32.4474 27.2148 31.5469C27.5749 31.2428 27.8874 31.0332 28.127 30.6182C29.0522 29.0125 27.7904 27.073 25.8789 27.1562ZM26.0029 14.333C22.9379 14.333 21.1455 16.7004 21.1455 18.6797V22.5029H30.8594L30.8604 22.502V18.6953C30.8601 16.7168 29.0677 14.333 26.0029 14.333Z'
          fill='#AF9DE0'
        />
      </g>
    </svg>
  );
}

FaqAccess.displayName = 'FaqAccess';

export default FaqAccess;
